import React, { Component } from 'react'

import { push } from 'connected-react-router'
import { connect } from 'react-redux'

import AudienceList from '../../components/AudienceList'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import BorderButton from '../../components/BorderButton'

import { Preloader } from '../../components/Chart/index'

import debounce from 'lodash/debounce'
import axios from 'axios'

import Alert from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'

import RoundBlueButton from '../../components/BorderButton/round-blue-button'
import './style.css'

import Multi from '../../components/Multi'
import ReactTooltip from 'react-tooltip'
import ACLCheckPermission from '../../components/ACLCheckPermission'
import UserRolesService from '../../lib/services/userRole/UserRolesService'

import { CSVDownload } from 'react-csv'
import XLSX from 'xlsx'





class Audiences extends Component {
    debouncedFilter = null

    state = {
        size: 10,
        offset: 0,
        filter: '',
        sort: 'creation',
        sortOrder: 'desc',
        licenseDetails: {},
        sizeDetails: {},
        sizeChartOptions: {},
        sizeDmp: 'ddp',
        syncAudienceDetails: {},
        licenseDetailsLoading: {},
        sizeDetailsLoading: {},
        syncAudienceDetailsLoading: {},
        sortDetails: 'creation',
        sortOrderDetails: 'asc',
        showDeleted: false,
        audiences: [],
        loading: false,
        showEdit: true,
        currentAudienceIdSelected: null,
        csvData: null,

    }

    componentDidMount() {
        let search = window.location.search
        let params = new URLSearchParams(search)
        console.log('events query params', params, params.get('filter'))
        this.setState(
            {
                filter: params.get('filter') || ''
            },
            () => {
                this.fetchAllAudiences(this.state.filter, this.state.size, this.state.offset, true)
                this.debouncedFilter = debounce(this.fetchAllAudiences, 300)
            }
        )

        // check if the user can see edit column
        let userService = new UserRolesService()
        userService.isEnabled('/audience', 'PATCH').then(active => {
            this.setState({ showEdit: active })
        })
    }

    onEdit(audience) {
        console.log('on edit audience ', '/audiences/edit/' + audience.audienceId)
        this.props.history.push({
            pathname: `/audiences/edit/${audience.audienceId}`,
            state: { audience: audience }
        })
    }

    onImport(audience) {
        console.log('on edit audience ', '/audiences/edit/' + audience.audienceId)
        this.props.history.push(
            '/audiences/import?importBtn=true&audienceId=' +
                audience.audienceId +
                '&audienceName=' +
                encodeURIComponent(audience.audienceName) +
                '&description=' +
                encodeURIComponent(audience.description)
        )
    }
    onHistory(audience) {
        this.props.history.push('/imports?filter=' + audience.audienceId)
    }
    onDelete(audience) {
        axios.request({ url: '/audience', method: 'DELETE', data: { audienceId: audience.audienceId } }).then(response => {
            console.log('delete', response, response.data.body)
            //window.location.reload()
            let index = this.state.audiences.findIndex(aud => aud.audienceId == audience.audienceId)
            console.log('delete index', index)
            this.state.audiences.splice(index, 1)
            this.componentDidMount()
        })
    }
    onRequeue(audience) {
        axios.get('/audience/requeue/' + audience.audienceId).then(response => {
            console.log('Requeue', response, response.data.body)
            Alert.success('Sync queued successfully!')
        })
    }
    onLicenseDetail(audienceId) {
        let licenseDetails = this.state.licenseDetails
        let licenseDetailsLoading = this.state.licenseDetailsLoading

        licenseDetails[audienceId] = []
        licenseDetailsLoading[audienceId] = true
        this.setState({ licenseDetailsLoading: licenseDetailsLoading, licenseDetails: licenseDetails }, () => {
            axios
                .get('/license?filter=' + audienceId + '&offset=0&size=100&sort=' + this.state.sortDetails + '&sortOrder=' + this.state.sortOrderDetails)
                .then(response => {
                    console.log('list', response, response.data.body)
                    let licenseDetails = this.state.licenseDetails
                    licenseDetails[audienceId] = response.data.body
                    licenseDetailsLoading[audienceId] = false
                    this.setState({ licenseDetailsLoading: licenseDetailsLoading, licenseDetails: licenseDetails })
                })
        })
    }

    onSyncAudienceDetails(audienceId) {
        let syncAudienceDetails = this.state.syncAudienceDetails
        let syncAudienceDetailsLoading = this.state.syncAudienceDetailsLoading

        syncAudienceDetails[audienceId] = []
        syncAudienceDetailsLoading[audienceId] = true
        this.setState({ syncAudienceDetailsLoading: syncAudienceDetailsLoading, syncAudienceDetails: syncAudienceDetails }, () => {
            axios.get('/event/sync/audience?keyType=audience_id&key=' + audienceId).then(response => {
                console.log('list', response, response.data.body)
                let syncAudienceDetails = this.state.syncAudienceDetails
                syncAudienceDetails[audienceId] = response.data.body
                syncAudienceDetailsLoading[audienceId] = false
                this.setState({ syncAudienceDetailsLoading: syncAudienceDetailsLoading, syncAudienceDetails: syncAudienceDetails })
            })
        })
    }
    onSortDetailsChange(sortField, audienceId) {
        console.log('sort details ', sortField, audienceId)

        let sort = this.state.sortDetails
        let sortOrder = this.state.sortOrderDetails
        if (sort != sortField) {
            sortOrder = 'asc'
        } else {
            // toggle if is the same field
            sortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
        }
        sort = sortField
        let offset = 0
        this.setState({ sortDetails: sort, sortOrderDetails: sortOrder })
        this.onLicenseDetail(audienceId)
    }

    onFilterChange(target) {
        let offset = 0
        this.setState({ offset: offset, filter: target.value })
        this.debouncedFilter(target.value, this.state.size, offset, true)
    }
    onLoadMore() {
        let offset = this.state.offset + this.state.size
        this.setState({ offset: offset })
        this.debouncedFilter(this.state.filter, this.state.size, offset, false, this.state.sort, this.state.sortOrder)
    }
    onSortChange(sortField) {
        let sort = this.state.sort
        let sortOrder = this.state.sortOrder
        if (sort != sortField) {
            sortOrder = 'asc'
        } else {
            // toggle if is the same field
            sortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
        }
        sort = sortField
        let offset = 0
        this.setState({ sort: sort, sortOrder: sortOrder, offset: offset })
        this.debouncedFilter(this.state.filter, this.state.size, offset, true, sort, sortOrder)
    }

    onShowDeleted() {
        let showDeleted = !this.state.showDeleted
        this.setState({ offset: 0 }, () => {
            this.debouncedFilter(this.state.filter, this.state.size, this.state.offset, true, this.state.sort, this.state.sortOrder, showDeleted)
            this.setState({ showDeleted: showDeleted })
        })
    }

    fetchAllAudiences(filter = '', size = 20, offset = 0, clear = false) {
        let query = `/audience?offset=${offset}&size=${size}&filter=${filter}&sort=${this.state.sort}&sortOrder=${this.state.sortOrder}&showDeleted=${this.state.showDeleted}`

        this.setState({ loading: true }, () => {
            axios.get(query).then(response => {
                let newAudiences = response.data.body
                let oldAudiences = []
                if (!clear) {
                    oldAudiences = this.state.audiences
                }
                oldAudiences = oldAudiences.concat(newAudiences)
                this.setState({ audiences: oldAudiences, loading: false })
            })
        })
    }

    // TODO - da fixare nel load e onchange - forse conviene fare una select + semplice...
    onDmpChange(dmp) {
        console.log('on dmp change ', dmp, 'stored aud ', this.state.currentAudienceIdSelected)
        this.setState({ sizeDmp: dmp }, () => {
            this.loadSizeChart(this.state.currentAudienceIdSelected, this.state.sizeDmp)
        })
    }
    onSizeDetail(audienceId) {
        let sizeDetails = this.state.sizeDetails
        let sizeDetailsLoading = this.state.sizeDetailsLoading
        let sizeDmp = this.state.sizeDmp

        // then load only for this audience
        sizeDetails[audienceId] = []
        sizeDetailsLoading[audienceId] = true
        this.setState({ currentAudienceIdSelected: audienceId, sizeDetailsLoading: sizeDetailsLoading, sizeDetails: sizeDetails }, () => {
            this.loadSizeChart(audienceId, sizeDmp)
        })
    }
    loadSizeChart(audienceId, sizeDmp) {
        let sizeDetailsLoading = this.state.sizeDetailsLoading

        axios.get('/audience/size/' + audienceId + '/' + sizeDmp).then(response => {
            console.log('list', response, response.data.body)
            let sizeDetails = this.state.sizeDetails
            sizeDetails[audienceId] = response.data.body
            sizeDetailsLoading[audienceId] = false

            // map data in 2 arrays: one for labels and one for values.

            let data = response.data.body || []

            // if a partner doesn't have any metrics, we don't show any graph!
            if (data.length == 0) {
                this.setState({ sizeDetailsLoading: sizeDetailsLoading, sizeDetails: sizeDetails })
                return
            }

            let labels = []
            let values = []
            data.map(el => {
                labels.push(new Date(el.label).toLocaleDateString())
                values.push(el.value)
            })

            let sizeChartOptions = this.state.sizeChartOptions

            let chartOptions = {
                chart: {
                    type: 'area'
                },
                credits: {
                    enabled: false
                },
                title: {
                    //text: 'UUID Mapping Calls'
                    text: ''
                },
                xAxis: {
                    categories: []
                },
                yAxis: {
                    allowDecimals: false,
                    title: {
                        text: ''
                    }
                },
                series: [
                    {
                        name: 'Size',
                        data: []
                    }
                ]
            }
            chartOptions.xAxis.categories = labels
            chartOptions.series[0].data = values
            console.log('SIZE chart ', chartOptions)

            sizeChartOptions[audienceId] = chartOptions

            this.setState({ sizeChartOptions: sizeChartOptions, sizeDetailsLoading: sizeDetailsLoading, sizeDetails: sizeDetails })
        })
    }


    // 
    // Export XLS
    //

    mapDataToCSV(list) {
        let csvData = []
        for (var i = 0; i < list.length; i++) {
            csvData.push({
                'audienceId': list[i]['audienceId'],
                'audienceName': list[i]['audienceName'],
                'alternativeId': list[i]['alternativeId'],
                'description': list[i]['description'],
                'sizeArCookie': list[i]['sizeArCookie'],
                'sizeArMobile': list[i]['sizeArMobile'],
                'sizeArCross': list[i]['sizeArCross'],
                'sizeDdp': list[i]['sizeDdp'],
                'sizeAdform': list[i]['sizeAdform'],
                'creation': list[i]['creation'],
                'partnerId': list[i]['partnerId'],
                //'durationInDays': list[i]['durationInDays'],
                //'deleted': list[i]['deleted'],
            })
        }
        return csvData
    }

    onCSVExport() {
        this.setState({ loading: true, csvData: null }, () => {
            

            axios.get("/audience/count").then(response=>{
                let count = response.data.body
                console.log("got max count", count)


                // paginate through a MAX of 20k licenses exported
                const maxExported = count;
                const maxLimit = 1000;
                let requests = [];
                for(let i = 0; i <= maxExported; i += maxLimit){ 
                    let url = `/audience?offset=${i}&size=${maxLimit}&filter=${this.state.filter}&sort=${this.state.sort}&sortOrder=${this.state.sortOrder}&showDeleted=false`
                    requests.push( axios.get(url) )
                }
                let jsonData = []
                axios.all(requests).then(axios.spread((...responses) => {
                    for(let i=0 ; i < responses.length; i++ ){ 
                        let response = responses[i];
                        //console.log("got response ", i, ", resp ", response)
                        let tmpJsonData = this.mapDataToCSV(response.data.body)
                        //console.log("got mapped ", tmpJsonData)
                        if(tmpJsonData && tmpJsonData.length > 0)
                            jsonData = jsonData.concat(tmpJsonData)
                    }
                    //console.log("processed all json ", jsonData)
    
                    this.setState({
                        loading: false
                    })
                    let fileName = 'Export_Audience_' + new Date().toGMTString() + '.xls'
                    this.exportToXSL(jsonData, fileName)
                }));

            })
             
            
        })
    }

    exportToXSL(jsonData, fileName) {
        let ws_name = 'Export'
        let ws = XLSX.utils.json_to_sheet(jsonData)

        // create a new workbook
        let wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, ws_name)

        // then save in XLS 2003 excel binary format so it will be super compatible!
        let type = 'biff8'
        XLSX.writeFile(wb, fileName || 'SheetJSTableExport.' + (type || 'xlsx'))
    }





    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <Multi>
                        <div className="row">
                            <div className="col-12">
                                <WhiteBox>
                                    <div className="row">
                                        <div className="col">
                                            <h3>Filter audiences</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="add-segment add-segment--search-field">
                                                <input
                                                    className="form-control"
                                                    placeholder="Start typing an audience name or id..."
                                                    value={this.state.filter}
                                                    onChange={({ target }) => this.onFilterChange(target)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </WhiteBox>
                            </div>
                        </div>

                        {this.state.loading && this.state.audiences.length === 0 ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                
                                    <WhiteBox>

                                        <div className="row">
                                            <div className="col-3">

                                          

                                                <h3>Your audiences</h3>
                                                <span style={{ fontSize: 'smaller', color: 'grey' }}>The size is calculated on the last 30 days</span>
                                            </div>
                                            <div className="col-2"></div>

                                            <div className="col text-right">
                                                <ACLCheckPermission api="/audience" method="POST">
                                                    <ReactTooltip id="createBtnTooltip" type="dark" effect="solid">
                                                        <span>Create a new Audience</span>
                                                    </ReactTooltip>
                                                    <button
                                                        data-tip
                                                        data-for="createBtnTooltip"
                                                        className="border-button inlinebuttons"
                                                        onClick={this.props.onCreateAudience}>
                                                        NEW AUDIENCE
                                                    </button>
                                                </ACLCheckPermission>
                                                &#160;
                                                <ACLCheckPermission api="/audience/bulk" method="POST">
                                                    <ReactTooltip id="bulkcreateBtnTooltip" type="dark" effect="solid">
                                                        <span>Bulk Create Audiences</span>
                                                    </ReactTooltip>
                                                    <button
                                                        data-tip
                                                        data-for="bulkcreateBtnTooltip"
                                                        className="border-button inlinebuttons"
                                                        onClick={this.props.onCreateAudienceBulk}>
                                                        BULK AUDIENCE
                                                    </button>
                                                </ACLCheckPermission>
                                                <ReactTooltip id="showDeletedBtnTooltip" type="dark" effect="solid">
                                                    {!this.state.showDeleted && <span>Show Deleted Audiences</span>}
                                                    {this.state.showDeleted && <span>Hide Deleted Audiences</span>}
                                                </ReactTooltip>
                                                <button
                                                    className="myborder-button inlinebuttons btn-sm"
                                                    style={{ marginLeft: '5px', paddingTop: '3px' }}
                                                    data-tip
                                                    data-for="showDeletedBtnTooltip"
                                                    onClick={this.onShowDeleted.bind(this)}>
                                                    {!this.state.showDeleted && <span>Show deleted</span>}
                                                    {this.state.showDeleted && <span>Hide deleted</span>}
                                                </button>

                                                <ReactTooltip id="exportLicenseBtnTooltip" type="dark" effect="solid">
                                                    <span>Export as Excel XLS File (MAX 20k items)</span>
                                                </ReactTooltip>
                                                &#160;
                                                <button
                                                    style={{ marginLeft: '0px', paddingTop: '0px' }}
                                                    className="border-button inlinebuttons "
                                                    data-tip
                                                    data-for="exportLicenseBtnTooltip"
                                                    href="#"
                                                    onClick={() => this.onCSVExport()}>
                                                        <i className="fa fa-file-excel-o fa-3" style={{ fontSize: '20px', top: '2px', position: 'relative' }}></i>&#160; Export
                                                        
                                                        {this.state.loading && (
                                                            <span className="login-loading-wrapper">
                                                                &#160;<i className="fa fa-spin fa-spinner" />
                                                            </span>
                                                        )}

                                                        
                                                </button>
                                                {/* render only if we have csv data */}
                                                {this.state.csvData != null && <CSVDownload filename={'export.csv'} data={this.state.csvData} />}
                                                

                                                
                                            </div>
                                        </div>

                                        {this.state.audiences.length > 0 && (
                                            <div class="table-responsive">
                                                <AudienceList
                                                    showEdit={this.state.showEdit}
                                                    onSortDetailsChange={this.onSortDetailsChange.bind(this)}
                                                    state={this.state}
                                                    history={this.props.history}
                                                    audiences={this.state.audiences}
                                                    onLoadMore={this.onLoadMore.bind(this)}
                                                    loading={this.state.loading}
                                                    sort={this.state.sort}
                                                    sortOrder={this.state.sortOrder}
                                                    onSortChange={this.onSortChange.bind(this)}
                                                    onEdit={this.onEdit.bind(this)}
                                                    onImport={this.onImport.bind(this)}
                                                    onHistory={this.onHistory.bind(this)}
                                                    onDelete={this.onDelete.bind(this)}
                                                    onLicenseDetail={this.onLicenseDetail.bind(this)}
                                                    onSizeDetail={this.onSizeDetail.bind(this)}
                                                    onDmpChange={this.onDmpChange.bind(this)}
                                                    onSyncAudienceDetails={this.onSyncAudienceDetails.bind(this)}
                                                    onRequeue={this.onRequeue.bind(this)}
                                                    size={this.state.size}
                                                    offset={this.state.offset}
                                                />
                                            </div>
                                        )}

                                        {this.state.audiences.length == 0 && (
                                            <div className="empty-page">
                                                <h2 className="empty-page empty-page--title">Create your First Audience. And the Next one.</h2>
                                                <div className="empty-page empty-page--subtitle" style={{ marginBottom: 30 }}>
                                                    Audiences are a collection of Users. Audiences can be used in your Campaigns.
                                                </div>
                                            </div>
                                        )}
                                    </WhiteBox>
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        onCreateAudience: () => push('/audiences/new'),
        onCreateAudienceBulk: () => push('/audiences/bulk-create'),
        onImportAudience: () => push('/audiences/import')
    }
)(Audiences)
